"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.constructionInvoke = exports.fetchTxns = exports.fetchBalances = exports.fetchBlockHeight = exports.getICPRosettaNetworkIdentifier = void 0;
const logs_1 = require("@ledgerhq/logs");
const env_1 = require("../../../../env");
const network_1 = __importDefault(require("@ledgerhq/live-network/network"));
const consts_1 = require("../../consts");
const getICPURL = (path) => {
    const baseUrl = (0, env_1.getEnv)("API_ICP_ENDPOINT");
    if (!baseUrl)
        throw new Error("API base URL not available");
    return `${baseUrl}${path ? path : ""}`;
};
const ICPFetchWrapper = (path, body) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const url = getICPURL(path);
    // We force data to this way as network func is not using the correct param type. Changing that func will generate errors in other implementations
    const opts = {
        method: "POST",
        data: body,
        url,
    };
    const rawResponse = yield (0, network_1.default)(opts);
    if (rawResponse && rawResponse.data && ((_a = rawResponse.data.details) === null || _a === void 0 ? void 0 : _a.error_message)) {
        (0, logs_1.log)("error", (_b = rawResponse.data.details) === null || _b === void 0 ? void 0 : _b.error_message);
    }
    // We force data to this way as network func is not using the correct param type. Changing that func will generate errors in other implementations
    const { data } = rawResponse;
    (0, logs_1.log)("http", url);
    return data;
});
const getICPRosettaNetworkIdentifier = () => {
    return {
        network_identifier: {
            blockchain: consts_1.ICP_BLK_NAME_ROSETTA,
            network: consts_1.ICP_NET_ID_ROSETTA,
        },
    };
};
exports.getICPRosettaNetworkIdentifier = getICPRosettaNetworkIdentifier;
const fetchBlockHeight = () => __awaiter(void 0, void 0, void 0, function* () {
    const data = yield ICPFetchWrapper("network/status", (0, exports.getICPRosettaNetworkIdentifier)());
    return data;
});
exports.fetchBlockHeight = fetchBlockHeight;
const fetchBalances = (accountId) => __awaiter(void 0, void 0, void 0, function* () {
    const body = Object.assign(Object.assign({}, (0, exports.getICPRosettaNetworkIdentifier)()), { account_identifier: {
            address: accountId,
            metadata: {},
        } });
    const data = yield ICPFetchWrapper("account/balance", body);
    return data;
});
exports.fetchBalances = fetchBalances;
const fetchTxns = (accountId) => __awaiter(void 0, void 0, void 0, function* () {
    const body = Object.assign(Object.assign({}, (0, exports.getICPRosettaNetworkIdentifier)()), { account_identifier: {
            address: accountId,
            metadata: {},
        } });
    const data = yield ICPFetchWrapper("search/transactions", body);
    return data;
});
exports.fetchTxns = fetchTxns;
const constructionInvoke = (opts, method) => __awaiter(void 0, void 0, void 0, function* () {
    const body = Object.assign({}, opts);
    const data = yield ICPFetchWrapper(`construction/${method}`, body);
    return data;
});
exports.constructionInvoke = constructionInvoke;
//# sourceMappingURL=api.js.map